define([
    './services/BaslerCommonService',
    './directives/BaslerEmailOffer',
    './directives/BaslerReferrer',
    './directives/BaslerSearchAddress',
    './directives/BaslerSideBySideOfferings',
    './directives/BaslerSummaryInfobox',
    './directives/BaslerShowContact',
    './directives/BaslerEditCoverage',
    './directives/BaslerPromotionModal',
    './services/BaslerContactTypeGenderSelector',
    './services/BaslerVehicleSearchService',
    './services/BaslerReferrerService',
    './filters/BaslerCurrencyFilter',
    './services/BaslerBrowserNavigationService',
], (BaslerCommonService,
    BaslerEmailOffer,
    BaslerReferrer,
    BaslerSearchAddress,
    BaslerSideBySideOfferings,
    BaslerSummaryInfobox,
    BaslerShowContact,
    BaslerEditCoverage,
    BaslerPromotionModal,
    BaslerContactTypeGenderSelector,
    BaslerVehicleSearchService,
    BaslerReferrerService,
    BaslerCurrencyFilter,
    BaslerBrowserNavigationService
) => {

    return angular.module('edge.quoteandbind.common.basler', [
        'edge.quoteandbind.common.app',
        'edge.quoteandbind.mfp.app',
        'edge.platform.base',
        'edge.platform.viewmodel.aspects',
        'edge.platform.widgets.modal',
        'edge.policyjob.app',
    ])
        .factory('BaslerCommonService', BaslerCommonService)

        .directive('qnbBaslerSideBySideOfferings', BaslerSideBySideOfferings)
        .directive('qnbBaslerEmailOffer', BaslerEmailOffer)
        .directive('qnbBaslerReferrer', BaslerReferrer)
        .directive('qnbBaslerSearchAddress', BaslerSearchAddress)

        .directive('baslerSummaryInfobox', BaslerSummaryInfobox)
        .directive('baslerShowContact', BaslerShowContact)
        .directive('baslerEditCoverage', BaslerEditCoverage)
        .directive('baslerPromotionModal', BaslerPromotionModal)

        .factory('BaslerContactTypeGenderSelector', BaslerContactTypeGenderSelector)
        .factory('BaslerVehicleSearchService', BaslerVehicleSearchService)
        .factory('BaslerReferrerService', BaslerReferrerService)
        .factory('BaslerBrowserNavigationService', BaslerBrowserNavigationService)

        .filter('BaslerCurrencyFilter', BaslerCurrencyFilter);
});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/baslercommon/app.js